(function () {
  const config = window.kabukiPromoConfig || {};
  const powderProductIds = Array.isArray(config.powderProductIds)
    ? config.powderProductIds.map((id) => Number(id)).filter(Boolean)
    : [];
  const brushProductId = Number(config.brushProductId || 0);
  const promoCode = typeof config.promoCode === 'string' ? config.promoCode.trim() : '';

  if (!powderProductIds.length || !brushProductId || !promoCode) return;

  const storageKey = `kabuki-promo:${promoCode.toLowerCase()}`;
  let isProcessing = false;
  let scheduledRun = null;

  function getAppliedDiscountCodes(cart) {
    return (Array.isArray(cart.discount_codes) ? cart.discount_codes : [])
      .map((item) => (typeof item === 'string' ? item : item && item.code) || '')
      .map((value) => String(value).trim())
      .filter(Boolean);
  }

  function scheduleSync(delay) {
    if (scheduledRun) window.clearTimeout(scheduledRun);
    scheduledRun = window.setTimeout(() => {
      scheduledRun = null;
      // Спільна черга з bundle-discount.js, щоб скрипти не перезаписували промокоди один одного
      const previous = window.__cartDiscountLock || Promise.resolve();
      window.__cartDiscountLock = previous.then(syncKabukiPromo, syncKabukiPromo).catch(() => {});
    }, delay);
  }

  function getDiscountApplications(cart) {
    const cartLevel = Array.isArray(cart.cart_level_discount_applications)
      ? cart.cart_level_discount_applications
      : [];
    const discountCodes = getAppliedDiscountCodes(cart);

    return [
      ...cartLevel.map((item) => item && (item.title || item.code || item.name || '')),
      ...discountCodes,
    ]
      .map((value) => String(value).trim().toLowerCase())
      .filter(Boolean);
  }

  function hasKabukiPromoApplied(cart, hasBrush) {
    const appliedValues = getDiscountApplications(cart);
    if (appliedValues.includes(promoCode.toLowerCase())) return true;

    if (!hasBrush) {
      sessionStorage.removeItem(storageKey);
      return false;
    }

    return sessionStorage.getItem(storageKey) === '1';
  }

  function getCartState(cart) {
    const eligiblePowders = cart.items.filter((item) => powderProductIds.includes(Number(item.product_id)));
    const brushLines = cart.items.filter((item) => Number(item.product_id) === brushProductId);

    return {
      hasEligiblePowder: eligiblePowders.length > 0,
      brushLines,
      hasBrush: brushLines.length > 0,
    };
  }

  async function fetchCart() {
    const response = await fetch(`${routes.cart_url}.js`, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Cart request failed with status ${response.status}`);
    }

    return response.json();
  }

  async function refreshMainCartFooter() {
    const footerRoot = document.getElementById('main-cart-footer');
    if (!footerRoot) return;

    const response = await fetch(`${routes.cart_url}?section_id=main-cart-footer`, {
      credentials: 'same-origin',
    });
    const html = await response.text();
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');
    const nextFooter = documentFragment.getElementById('main-cart-footer');

    if (nextFooter) {
      footerRoot.innerHTML = nextFooter.innerHTML;
      footerRoot.className = nextFooter.className;
    }
  }

  async function refreshRenderedCart() {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kabuki-promo' });
    }

    await refreshMainCartFooter();
    document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
      bubbles: true,
      detail: { source: 'kabuki-promo' },
    }));
  }

  function setPromoProcessing(isActive) {
    document.querySelectorAll('cart-drawer, cart-items').forEach((element) => {
      element.classList.toggle('kabuki-promo-loading', isActive);
      element.setAttribute('aria-busy', isActive ? 'true' : 'false');
    });
  }

  async function updateCartDiscount(discountCodes) {
    setPromoProcessing(true);

    const response = await fetch(routes.cart_update_url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        discount: discountCodes.join(','),
      }),
    });

    if (!response.ok) {
      throw new Error(`Discount update failed with status ${response.status}`);
    }

    await response.json();
    await refreshRenderedCart();
  }

  async function applyPromoCode(cart) {
    const nextDiscountCodes = Array.from(
      new Set(
        [...getAppliedDiscountCodes(cart), promoCode].map((value) => String(value).trim()).filter(Boolean)
      )
    );

    await updateCartDiscount(nextDiscountCodes);
    sessionStorage.setItem(storageKey, '1');
  }

  async function removePromoCode(cart) {
    const nextDiscountCodes = getAppliedDiscountCodes(cart).filter(
      (code) => code.toLowerCase() !== promoCode.toLowerCase()
    );

    await updateCartDiscount(nextDiscountCodes);
    sessionStorage.removeItem(storageKey);
  }

  async function syncKabukiPromo() {
    if (isProcessing) return;
    isProcessing = true;
    const endCheckoutBusy = window.cartCheckoutBusy?.begin();

    try {
      const cart = await fetchCart();
      const { hasEligiblePowder, hasBrush } = getCartState(cart);
      const promoApplied = hasKabukiPromoApplied(cart, hasBrush);

      if (!hasEligiblePowder || !hasBrush) {
        if (promoApplied) {
          await removePromoCode(cart);
        }
        sessionStorage.removeItem(storageKey);
        return;
      }

      if (!promoApplied) {
        await applyPromoCode(cart);
      }
    } catch (error) {
      console.error('Kabuki promo sync failed:', error);
    } finally {
      setPromoProcessing(false);
      isProcessing = false;
      endCheckoutBusy?.();
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    scheduleSync(400);
  });

  document.addEventListener('cart:updated', function (event) {
    if (event.detail?.source === 'kabuki-promo') return;
    scheduleSync(300);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'kabuki-promo') return;
      scheduleSync(300);
    });
  }
})();
